<script setup>
	import { ref, watch, onBeforeUnmount, onMounted, computed } from 'vue';
	import { useMapStoreData, useSetMap, useCategoriesStore, useSearchData, useScreensaverStore } from '@/stores/index';
	import closeIcon from '@/assets/close-marker-dark.svg';
	import searchIcon from '@/assets/menu/search-icon.svg';
	import { useRoute } from 'vue-router';
	import Keyboard from '@/components/Keyboard.vue';
	// @ts-ignore
	import { useI18n } from 'vue-i18n';
	const searchOpened = ref(false);
	const keyboardOpened = ref(true);
	const input = ref('');
	const keyboardInputConst = ref('');
	const mapStore = useMapStoreData();
	const newSearch = ref('');
	const route = useRoute();
	const currentURL = ref(route.fullPath);
	const passCurrentInput = ref('');
	const { t } = useI18n();
	const searchMaxWidth = ref('');
	const searchMinWidth = ref('12.1354166667');
	function goToMarker(id) {
		keyboardOpened.value = false;
		const title = t(id + '.title');
		mapStore.poiPopularity(id);
		input.value = title;
		useMapStoreData().activePoi = id;
		if (currentURL.value == '/scenarios/') {
			console.log('scenarios');
		} else {
			let map1 = {
				type: 'FeatureCollection',
				features: [],
			};

			map1.features = mapStore.clusters.features.filter((e) => {
				if (e.id == id) {
					return e;
				}
			});

			useSetMap().setMapData(map1);

			if (
				useMapStoreData().markers &&
				useMapStoreData().markers[id] &&
				useMapStoreData().markers[id].geometry &&
				useMapStoreData().markers[id].geometry.coordinates
			) {
				const clickedCoordinates = useMapStoreData().markers[id].geometry.coordinates;
				let zoom = 16;
				if (useSetMap().map.getZoom() > 16) {
					zoom = useSetMap().map.getZoom();
				}

				const width = window.innerWidth;
				let offset = 0;

				// Calculate offset to center POI in the visible map area (accounting for POI card width)
				if (width <= 833) {
					// Mobile: card takes full width, no offset needed
					offset = -50;
				} else if (width < 1600) {
					// Desktop: card takes 65% of width, center POI in remaining 35% visible area
					// Calculate offset to move POI to the center of the visible map area (left side)
					const cardWidthPercent = 0.65; // Card takes 65% of screen width
					const visibleMapWidthPercent = 1 - cardWidthPercent; // Remaining 35% is visible map
					const centerOfVisibleArea = cardWidthPercent + visibleMapWidthPercent / 2; // Center of visible area
					const screenCenter = 0.5; // Center of entire screen
					const offsetPercent = centerOfVisibleArea - screenCenter; // Difference to move POI to visible center
					offset = -offsetPercent * width; // Convert to pixels and negate to move left
				} else {
					// Large screens: use smaller offset for better positioning
					offset = -width * 0.1; // Move POI slightly left of center
				}

				useSetMap().map.flyTo({
					center: [clickedCoordinates[0], clickedCoordinates[1]],
					zoom: zoom,
					offset: [offset, 0],
				});
			}
		}
	}

	function toggleSearch() {
		searchOpened.value = !searchOpened.value;
		if (searchOpened.value == false) {
			console.log('close!');
			resetSearch();
		} else {
			console.log('search open!');
		}
	}

	function openSearch() {
		console.log('openSearch');

		input.value = keyboardInputConst.value;
		passCurrentInput.value = input.value;

		searchOpened.value = true;
		keyboardOpened.value = true;
	}

	function closeSearch() {
		resetSearch();
	}

	function keyboardInput(keyinput) {
		input.value = keyinput;
		keyboardInputConst.value = keyinput;
	}

	function closeKeyboard() {
		console.log('closeKeyboard');
		keyboardOpened.value = false;
	}

	function resetSearch(closedPoi = false) {
		useSearchData().searchFilteredItems = [];
		const filtersToCheck =
			useCategoriesStore().selectedFilters.length > 0
				? useCategoriesStore().selectedFilters
				: useCategoriesStore().activeFilters;
		if (filtersToCheck.length == useCategoriesStore().maxFilters) {
			useSetMap().setAllMarkersData();
		} else {
			useSetMap().returnFilteredMarkersMap();
		}

		if (closedPoi) {
			input.value = keyboardInputConst.value;
		} else {
			input.value = '';
			keyboardInputConst.value = '';
			searchOpened.value = false;
			keyboardOpened.value = true;
			useSearchData().activePoi = null;
		}
	}

	const filterMarkers = (poiCategories) => {
		if (useCategoriesStore().activeFilters.length == 0) {
			return true;
		}
		const hasActiveFilter = poiCategories.some((category) => useCategoriesStore().activeFilters.includes(category));
		return hasActiveFilter;
	};

	onBeforeUnmount(() => {
		resetSearch();
	});

	onMounted(() => {
		if (window.innerWidth <= 999) {
			searchMaxWidth.value = '39.7395833333';
		} else {
			searchMaxWidth.value = '29.7395833333';
		}
	});

	const inputWidth = computed(() => {
		const baseWidth = window.innerWidth <= 999 ? '26.1354vw' : '18.2291666667vw';
		if (searchOpened.value && input.value.length > 15) {
			return `${input.value.length}vw`;
		}
		return baseWidth;
	});

	watch(
		() => input.value,
		(newInput) => {
			if (newInput.length == 0) {
				useSearchData().searchFilteredItems = [];
				return;
			}
			useSearchData().searchFilteredItems = [];
			var isTagFound = false;
			var inArray = false;
			const tags = mapStore.dataSelectors.tags;

			for (const key in mapStore.markers) {
				if (Object.prototype.hasOwnProperty.call(mapStore.markers, key)) {
					const feature = mapStore.markers[key];

					//drejc dodano iskanje po tagih
					isTagFound = false;

					for (let i = 0; i < tags.length; i++) {
						inArray = false;
						if (Array.isArray(feature.properties.tags))
							for (const item of feature.properties.tags) {
								if (item == tags[i].id) {
									inArray = true;
									break;
								}
							}

						if (
							inArray &&
							(tags[i].name.toLowerCase().includes(newInput.toLowerCase()) ||
								(tags[i].locale != undefined &&
									tags[i].locale[mapStore.currentLanguage] != undefined &&
									tags[i].locale[mapStore.currentLanguage].toLowerCase().includes(newInput.toLowerCase())))
						) {
							//console.log('isTagFound', feature.properties.title)
							isTagFound = true;
							break;
						}
					}

					//drejc ne vem kako dodat v listo rezultatov
					const title = t(feature.properties.id + '.title');
					if (title.toLowerCase().includes(newInput.toLowerCase()) || isTagFound) {
						newSearch.value = title;

						//console.log('proavamo dodat ' +title+ ' ker vsebuj '+newInput.toLowerCase() + ' tagfound '+ isTagFound)
						if (filterMarkers(feature.properties.categories)) {
							useSearchData().searchFilteredItems.push(feature);
						}
					}
				}
			}
		}
	);

	/*watch(() => input.value,
	   (newInput, oldInput) => {
	     useSearchData().searchFilteredItems = [];
	     for (const key in mapStore.markers) {
	       if (mapStore.markers.hasOwnProperty(key)) {
	         const feature = mapStore.markers[key];
	         const title = t(feature.properties.id + '.title')
	         if(title.toLowerCase().includes(newInput.toLowerCase())){
	           newSearch.value = title;
	           if(filterMarkers(feature.properties.categories)) {
	             useSearchData().searchFilteredItems.push(feature);
	           }
	         }
	       }
	     }
	 });*/

	// watch(
	// 	() => searchOpened,
	// 	(newValue) => {
	// 		if (newValue == null || newValue == false) {
	// 			resetSearch();
	// 		}
	// 	}
	// );

	watch(
		() => useScreensaverStore().showSreensaver,
		(newValue) => {
			if (newValue == true) {
				resetSearch();
			}
		}
	);
	watch(
		() => useMapStoreData().activePoi,
		(newValue) => {
			if (newValue == null && route.path !== '/scenarios/') {
				resetSearch(true);
			}
		}
	);
</script>
<template>
	<div
		class="search-position"
		v-show="!useMapStoreData().isMapCopyMode && ((currentURL == '/scenarios/' && useMapStoreData().activePoi == null) || useMapStoreData().showMap)"
	>
		<div v-if="currentURL != '/scenarios/'">
			<ul
				v-if="input.length > 0 && keyboardOpened && useSearchData().searchFilteredItems.length > 0"
				class="autocomplete"
			>
				<li @click="goToMarker(item.properties.id)" v-for="item in useSearchData().searchFilteredItems" :key="item">
					{{ t(item.properties.id + '.title') }}
				</li>
			</ul>
		</div>

		<div
			:style="{ minWidth: searchMinWidth + 'vw', width: inputWidth, maxWidth: searchMaxWidth + 'vw' }"
			class="search-item"
			data-cy="search-item"
			@click="openSearch"
			:class="{ active: searchOpened }"
		>
			<span v-if="!searchOpened">{{ t('general.search') }}</span>
			<input
				style="pointer-events: none"
				:placeholder="t('general.search')"
				v-model="input"
				type="text"
			/>
			<div class="line"></div>
			<img class="glass" :src="searchIcon" alt="" />

			<img class="close" @click.stop="closeSearch" :src="closeIcon" alt="" />
		</div>
		<Teleport to="body">
			<div v-if="searchOpened">
				<Keyboard
					v-show="keyboardOpened"
					@closeSearch="toggleSearch"
					@keyboardInput="keyboardInput"
					@closeKeyboard="closeKeyboard"
				></Keyboard>
			</div>
		</Teleport>
	</div>
</template>
<style scoped lang="scss">
	@import '../assets/style/mixins.scss';
	@import '../assets/style/components/search';
</style>
